import { IImportedEan } from '~/common/types';

type UIState =
  | { type: 'UPLOAD'; file?: File }
  | { type: 'PRICING'; eans: IImportedEan[]; file: File };

type UIAction =
  | { type: 'SHOW_PRICING_TABLE'; eans: Array<IImportedEan>; file: File }
  | { type: 'RESET' };

export function reducer(state: UIState, action: UIAction): UIState {
  switch (action.type) {
    case 'SHOW_PRICING_TABLE':
      return {
        type: 'PRICING',
        eans: action.eans,
        file: action.file,
      };

    case 'RESET':
      return { type: 'UPLOAD', file: state.file };
    default:
      return state;
  }
}
